import { forwardRef } from 'react'
import { IconProps } from '../Types'

export const TableBorder = forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', size = 16 }, forwardedRef) => {
    return (
      <svg
        width={size}
        height={size}
        style={{ width: size, height: size }}
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={forwardedRef}
      >
        <g stroke={color}>
          <rect x="2.5" y="2.5" width="11" height="11" />
          <rect x="2.5" y="2.5" width="5.6" height="11" />
          <rect x="2.5" y="2.5" width="11" height="5.6" />
        </g>
      </svg>
    )
  },
)

export default TableBorder
